export const quickJournalDuneTheme = {
        id: "dune",
        label: "Dune",
        containerClassName: "QuickJournalContainerDuneV1",
        overlay: {
            backgroundColor: `rgb(79, 43, 26)`,
            backgroundImage:
                `radial-gradient(ellipse at 50% 100%, rgba(255, 185, 96, 0.18), transparent 58%), ` +
                `linear-gradient(to bottom, rgba(255, 220, 145, 0.4) 0%, rgba(232, 153, 73, 0.27) 24%, rgba(158, 78, 39, 0.23) 56%, rgba(91, 46, 27, 0.2) 100%), ` +
                `linear-gradient(to bottom, rgba(255, 231, 168, 0.16) 0%, rgba(214, 140, 66, 0.09) 36%, rgba(84, 38, 27, 0.03) 68%, rgba(36, 24, 14, 0) 100%), ` +
                `radial-gradient(circle at 43% 9%, rgba(255, 232, 170, 0.24), transparent 24%), ` +
                `radial-gradient(circle at 67% 12%, rgba(255, 176, 78, 0.2), transparent 26%), ` +
                `radial-gradient(circle at 28% 14%, rgba(141, 86, 40, 0.44) 0 7%, transparent 17%), ` +
                `radial-gradient(circle at 44% 22%, rgba(109, 62, 33, 0.48) 0 6%, transparent 15%), ` +
                `radial-gradient(circle at 63% 18%, rgba(164, 96, 42, 0.40) 0 7%, transparent 18%), ` +
                `radial-gradient(circle at 76% 28%, rgba(126, 72, 36, 0.44) 0 6%, transparent 16%), ` +
                `radial-gradient(circle at 18% 36%, rgba(96, 53, 28, 0.36) 0 8%, transparent 18%), ` +
                `radial-gradient(circle at 52% 40%, rgba(164, 101, 44, 0.28) 0 10%, transparent 24%), ` +
                `radial-gradient(circle at 83% 42%, rgba(118, 72, 34, 0.34) 0 8%, transparent 18%)`,
        },
        backdrop: {
            backgroundColor: "rgb(47, 32, 26)",
            topIos: "calc(100% - 12px)",
            topDefault: "calc(100% - 7px)",
            width: "max(640px, 100vw)",
            height: "280px",
            minHeight: "280px",
            maxHeight: "280px",
            background: `
                radial-gradient(
                    circle 280px at 50% 0px,
                    rgba(214, 146, 74, 0.12) 0%,
                    rgba(159, 90, 48, 0.08) 18%,
                    rgba(112, 67, 48, 0.04) 34%,
                    rgba(68, 48, 50, 0.02) 56%,
                    rgba(0, 0, 0, 0) 100%
                ),
                radial-gradient(
                    circle 170px at 50% 0px,
                    rgba(221, 153, 84, 0.05) 0%,
                    rgba(221, 153, 84, 0.025) 20%,
                    rgba(255, 192, 104, 0) 100%
                ),
                radial-gradient(
                    circle 210px at 50% 18px,
                    rgba(207, 131, 66, 0.04) 0%,
                    rgba(207, 131, 66, 0.02) 28%,
                    rgba(255, 177, 82, 0) 100%
                ),
                linear-gradient(
                    to bottom,
                    rgba(210, 116, 52, 0.06) 0%,
                    rgba(103, 54, 40, 0.1) 12%,
                    rgba(42, 30, 43, 0.16) 30%,
                    rgba(10, 11, 19, 0) 48%
                ),
                linear-gradient(
                    to bottom,
                    rgba(64, 40, 30, 0.15) 0%,
                    rgba(82, 50, 34, 0.3) 18%,
                    rgba(62, 43, 34, 0.45) 55%,
                    rgba(46, 33, 28, 0.64) 100%
                )`,
            boxShadow:
                "inset 0 14px 40px rgba(255, 184, 87, 0.035), inset 0 -48px 120px rgba(20, 16, 13, 0.22)",
        },
        recentEntry: {
            color: "rgba(255, 241, 222, 0.97)",
            textShadow: "0 0 12px rgba(255, 166, 74, 0.13)",
            timestampColor: "rgba(255, 220, 180, 0.88)",
        },
        input: {
            color: "#ffd09a",
            cursorLow: "#9f5a2b",
            cursorMid: "#cf752f",
            cursorHigh: "#ff9a3c",
        },
        heatmap: {
            containerColor: "rgba(255, 220, 184, 0.94)",
            cellBackground: (level: number) => {
                if (level <= 0) return "rgba(255, 220, 184, 0.05)";
                if (level >= 4) return "rgba(255, 170, 78, 0.96)";
                if (level === 3) return "rgba(255, 142, 59, 0.9)";
                if (level === 2) return "rgba(214, 109, 42, 0.82)";
                return "rgba(117, 64, 34, 0.66)";
            },
            cellBoxShadow: "0 0 8px rgba(255, 138, 48, 0.1)",
            flashBoxShadow: "0 0 12px rgba(255, 255, 255, 0.92)",
            hoverOutline: "1px solid rgba(255, 233, 210, 0.94)",
            inactiveOpacity: 0.34,
            activeOpacity: 1,
        },
        toggle: {
            color: "#ff9d4d",
            opacity: 0.82,
            shadow: "drop-shadow(0px 0px 6px rgba(117, 52, 15, 0.5))",
            transform: "rotate(-135deg)",
        },
        switcher: {
            border: "rgba(255, 170, 78, 0.24)",
            background: "rgba(36, 17, 16, 0.52)",
            text: "rgba(255, 227, 208, 0.88)",
            activeBackground: "rgba(255, 136, 61, 0.22)",
            activeText: "rgba(255, 241, 229, 0.98)",
            activeBorder: "rgba(255, 160, 76, 0.58)",
        },
    } as const;
